import { render, staticRenderFns } from "./SessionObservation.vue?vue&type=template&id=5c7df2fd&scoped=true"
import script from "./SessionObservation.vue?vue&type=script&lang=js"
export * from "./SessionObservation.vue?vue&type=script&lang=js"
import style0 from "./SessionObservation.vue?vue&type=style&index=0&id=5c7df2fd&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c7df2fd",
  null
  
)

export default component.exports